import { boot } from '@giscube/geoportal'

import configMapia from './config'
import except from './except'
import i18nMapia from './i18n'
import flags from './flags'

function setup (conf = {}) {
  return async function () {
    // specialization supported
    const config = configMapia.setup(conf.config)
    const i18n = i18nMapia.setup(conf.i18n)

    await boot({ config, i18n }).apply(this, arguments)

    // simple imports without specialization
    await except.apply(this, arguments)
    await flags.apply(this, arguments)
  }
}

const geoportalBoot = setup()
geoportalBoot.setup = setup

export default geoportalBoot
